import Tasks from 'APP/Tasks';
import { RefreshTokenInitiator } from 'APP/Tasks/authorization/login/login.types';
import { logout } from 'APP/Tasks/authorization/logout/logout';
import {
  dispatchUntrustedRealtimeEvents,
  initUntrustedRealtimeEvents,
} from 'APP/Tasks/realtimeEvent/realTimeEvents';
import { uniffiInitAsync } from 'APP/libs/mls-rs-wasm';
import { IDeviceKeyPackagesCount } from 'APP/model/auth/authModel.types';
import { IDeviceStatusUpdateEvent } from 'APP/model/counter/counterModel.types';
import { DeviceStatus } from 'APP/model/userSettings/userSettingsModel.types';
import { ProjectUrls } from 'APP/packages/projectUrls/ProjectUrls';
import { storage } from 'APP/packages/storage';
import { wsUntrustedApiConnect, wsUntrustedApiDisconnect } from 'APP/wsApi/wsApi';
import { MlsStorageService } from 'SERVICES/mlsStorageService/MlsStorageService';
import { WebCryptoService } from 'SERVICES/webCryptoService/WebCryptoService';
import Entities from 'STORE';

import { refreshToken } from './refreshToken';

interface IInitUntrustedProjectParams {
  userId: string;
  accessToken: string;
  deviceKeyPackagesCount: IDeviceKeyPackagesCount | null;
  refreshToken: string;
}

export async function initUntrustedProject(
  params: IInitUntrustedProjectParams
): Promise<{ result: boolean }> {
  await Tasks.config.updateHostConfig();
  storage.refreshToken.set(params.refreshToken);
  Entities.authStore.setSession(params.accessToken);
  if (!ProjectUrls.isCorrectConfig) {
    return { result: false };
  }

  wsUntrustedApiConnect(params.accessToken, async () => {
    const result = await refreshToken(false, RefreshTokenInitiator.WsApp);

    if (result.isSuccess && result.token) {
      return result.token;
    } else {
      return logout().then(() => null);
    }
  });

  await uniffiInitAsync();
  await MlsStorageService.initMlsGroupStorage(params.userId);
  await WebCryptoService.init(params.userId);

  if (params.deviceKeyPackagesCount && params.deviceKeyPackagesCount.missingCount) {
    Tasks.e2ee.uploadKeyPackages(params.deviceKeyPackagesCount.missingCount, true);
  }

  const promiseResult = await new Promise((resolve) => {
    initUntrustedRealtimeEvents((data: IDeviceStatusUpdateEvent) => {
      if (data.status === DeviceStatus.Trusted) {
        dispatchUntrustedRealtimeEvents();
        wsUntrustedApiDisconnect();
        resolve(true);
      } else if (data.status === DeviceStatus.Blocked) {
        dispatchUntrustedRealtimeEvents();
        wsUntrustedApiDisconnect();
        resolve(false);
      }
    });
  });

  if (!promiseResult) {
    return { result: false };
  }

  dispatchUntrustedRealtimeEvents();
  return { result: true };
}
